/**
 * Header logo scroll class toggle
 * Adds a class when window top reaches container top minus header-spacer height
 * Only works when body has page-home class
 */

export const headerLogoScroll = () => {
  // Check if body has page-home class
  const body = document.body;
  if (!body.classList.contains('page-home')) {
    return;
  }

  // Get the required elements
  const container = document.querySelector('.site-container');
  const headerSpacer = document.querySelector('.header-spacer');

  if (!container || !headerSpacer) {
    console.warn('Container or header-spacer element not found');
    return;
  }

  // Configuration
  const targetClass = 'is-header-logo-reached'; // Class to add to body
  const threshold = 1; // Pixels of buffer zone to prevent flickering
  let isClassAdded = false;
  let ticking = false;
  let cachedTargetPosition = null;

  // Calculate the target position: container top - header-spacer height (with caching)
  const getTargetPosition = (forceRecalculate = false) => {
    if (!forceRecalculate && cachedTargetPosition !== null) {
      return cachedTargetPosition;
    }

    const containerRect = container.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const containerTop = containerRect.top + scrollTop;
    const headerSpacerHeight = headerSpacer.offsetHeight;

    cachedTargetPosition = containerTop - headerSpacerHeight;
    return cachedTargetPosition;
  };

  // Handle scroll event
  const handleScroll = () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const targetPosition = getTargetPosition();

        // Add threshold to prevent flickering
        // Add class when scrolling down past the target
        // Remove class when scrolling up past the target minus threshold
        const shouldAddClass = scrollTop >= targetPosition;
        const shouldRemoveClass = scrollTop < (targetPosition - threshold);

        if (shouldAddClass && !isClassAdded) {
          body.classList.add(targetClass);
          isClassAdded = true;

          // Dispatch custom event for other modules to listen
          window.dispatchEvent(new CustomEvent('headerLogoReached', {
            detail: { scrollTop, targetPosition }
          }));
        } else if (shouldRemoveClass && isClassAdded) {
          body.classList.remove(targetClass);
          isClassAdded = false;

          // Dispatch custom event for other modules to listen
          window.dispatchEvent(new CustomEvent('headerLogoLeft', {
            detail: { scrollTop, targetPosition }
          }));
        }

        ticking = false;
      });
      ticking = true;
    }
  };

  // Debounced resize handler to recalculate positions
  let resizeTimeout;
  const handleResize = () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      // Force recalculate position on resize
      getTargetPosition(true);
      handleScroll(); // Re-check position after resize
    }, 250);
  };

  // Initial calculation and check
  getTargetPosition(true); // Force initial calculation
  // Use setTimeout to ensure DOM is fully ready
  setTimeout(() => {
    handleScroll();
  }, 100);

  // Add event listeners
  window.addEventListener('scroll', handleScroll, { passive: true });
  window.addEventListener('resize', handleResize, { passive: true });

  // Optional: Log for debugging
  console.log('Header logo scroll module initialized for page-home with container-based trigger');
};